import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 诚信登记服务
 */
export class IntegrityControllerSvr {
    constructor() {
        this.baseurl = 'IntegrityControllerSvr.assx/';
    }

    /**
     * 获取配置文件
     * token:String, scene:String
     */
    getImportantConfigList(token, scene){
        return request.post(this.baseurl + 'getImportantConfigList', Qs.stringify({ token:token, scene:scene }));
    }

    /**
     * 暂存良好行为申报业务单
     * token:String, doc:BusinessDoc, taskName:String, workFlowTemplateName:String, docBody:IntegrityRegisterDoc, importantDocs:ImportantDocList
     */
    tempSaveGoodIntegrityDoc(token, doc, taskName, workFlowTemplateName, docBody, importantDocs){
        return request.post(this.baseurl + 'tempSaveGoodIntegrityDoc', Qs.stringify({ token:token, doc:typeof doc === 'undefined' || doc === null ? '' : doc.toString(), taskName:taskName, workFlowTemplateName:workFlowTemplateName, docBody:typeof docBody === 'undefined' || docBody === null ? '' : docBody.toString(), importantDocs:typeof importantDocs === 'undefined' || importantDocs === null ? '' : importantDocs.toString() }));
    }

    /**
     * 获取行政区域名称
     * token:String, cantonCode:String
     */
    getCantonName(token, cantonCode){
        return request.post(this.baseurl + 'getCantonName', Qs.stringify({ token:token, cantonCode:cantonCode }));
    }

    /**
     * 发布公告
     * token:String, keyID:String, docCode:String
     */
    publishIntegrityRegister(token, keyID, docCode){
        return request.post(this.baseurl + 'publishIntegrityRegister', Qs.stringify({ token:token, keyID:keyID, docCode:docCode }));
    }

    /**
     * 通过业务单单号获取业务单
     * token:String, docCode:String
     */
    getBusinessDocDetailByDocCode(token, docCode){
        return request.post(this.baseurl + 'getBusinessDocDetailByDocCode', Qs.stringify({ token:token, docCode:docCode }));
    }

    /**
     * 提交良好行为申报业务单
     * token:String, doc:BusinessDoc, taskName:String, workFlowTemplateName:String, docBody:IntegrityRegisterDoc, importantDocs:ImportantDocList
     */
    submiteGoodBehaviorRegisterDoc(token, doc, taskName, workFlowTemplateName, docBody, importantDocs){
        return request.post(this.baseurl + 'submiteGoodBehaviorRegisterDoc', Qs.stringify({ token:token, doc:typeof doc === 'undefined' || doc === null ? '' : doc.toString(), taskName:taskName, workFlowTemplateName:workFlowTemplateName, docBody:typeof docBody === 'undefined' || docBody === null ? '' : docBody.toString(), importantDocs:typeof importantDocs === 'undefined' || importantDocs === null ? '' : importantDocs.toString() }));
    }

    /**
     * 获取企业信息诚信统计信息
     * token:String
     */
    GetRealtyComIntegrityStatics(token){
        return request.post(this.baseurl + 'GetRealtyComIntegrityStatics', Qs.stringify({ token:token }));
    }

    /**
     * 获取诚信配置信息
     * token:String, isRecord:boolean
     */
    GetIntegrityConfigRoot(token, isRecord){
        return request.post(this.baseurl + 'GetIntegrityConfigRoot', Qs.stringify({ token:token, isRecord:isRecord }));
    }

    /**
     * 新增诚信登记
     * token:String, register:IntegrityRegister
     */
    AddIntegrityRegister(token, register){
        return request.post(this.baseurl + 'AddIntegrityRegister', Qs.stringify({ token:token, register:typeof register === 'undefined' || register === null ? '' : register.toString() }));
    }

    /**
     * 通过id获取单个诚信登记记录
     * token:String, keyID:String
     */
    GetIntegrityRegister(token, keyID){
        return request.post(this.baseurl + 'GetIntegrityRegister', Qs.stringify({ token:token, keyID:keyID }));
    }

    /**
     * 暂存诚信登记业务单
     * token:String, doc:BusinessDoc, taskName:String, workFlowTemplateName:String, docBody:IntegrityRegisterDoc, importantDocs:ImportantDocList
     */
    tempSaveIntegrityDoc(token, doc, taskName, workFlowTemplateName, docBody, importantDocs){
        return request.post(this.baseurl + 'tempSaveIntegrityDoc', Qs.stringify({ token:token, doc:typeof doc === 'undefined' || doc === null ? '' : doc.toString(), taskName:taskName, workFlowTemplateName:workFlowTemplateName, docBody:typeof docBody === 'undefined' || docBody === null ? '' : docBody.toString(), importantDocs:typeof importantDocs === 'undefined' || importantDocs === null ? '' : importantDocs.toString() }));
    }

    /**
     * 修改业务单
     * token:String, docCode:String, summary:String, cantonCode:String, remark:String, docBodyJSON:String, importantDocs:ImportantDocList
     */
    modifyIntegrityRegisterDoc(token, docCode, summary, cantonCode, remark, docBodyJSON, importantDocs){
        return request.post(this.baseurl + 'modifyIntegrityRegisterDoc', Qs.stringify({ token:token, docCode:docCode, summary:summary, cantonCode:cantonCode, remark:remark, docBodyJSON:docBodyJSON, importantDocs:typeof importantDocs === 'undefined' || importantDocs === null ? '' : importantDocs.toString() }));
    }

    /**
     * 新增诚信登记业务单
     * token:String, doc:BusinessDoc, docBody:IntegrityRegisterDoc, importantDocs:ImportantDocList
     */
    addIntegrityRegisterDoc(token, doc, docBody, importantDocs){
        return request.post(this.baseurl + 'addIntegrityRegisterDoc', Qs.stringify({ token:token, doc:typeof doc === 'undefined' || doc === null ? '' : doc.toString(), docBody:typeof docBody === 'undefined' || docBody === null ? '' : docBody.toString(), importantDocs:typeof importantDocs === 'undefined' || importantDocs === null ? '' : importantDocs.toString() }));
    }

    /**
     * 保存诚信报告列表记录
     * token:String, oper:String, reportName:String, beginDate:String, endDate:String, isSave:boolean, title:String
     */
    OperateIntegrityRegisterNotice(token, oper, reportName, beginDate, endDate, isSave, title){
        return request.post(this.baseurl + 'OperateIntegrityRegisterNotice', Qs.stringify({ token:token, oper:oper, reportName:reportName, beginDate:beginDate, endDate:endDate, isSave:isSave, title:title }));
    }

    /**
     * 删除诚信记录
     * token:String, keyID:String
     */
    DeleteIntegrityRegisterNotice(token, keyID){
        return request.post(this.baseurl + 'DeleteIntegrityRegisterNotice', Qs.stringify({ token:token, keyID:keyID }));
    }

    /**
     * 新增良好行为登记业务单
     * token:String, doc:BusinessDoc, docBody:IntegrityRegisterDoc, importantDocs:ImportantDocList
     */
    addGoodBBehaviorRegisterDoc(token, doc, docBody, importantDocs){
        return request.post(this.baseurl + 'addGoodBBehaviorRegisterDoc', Qs.stringify({ token:token, doc:typeof doc === 'undefined' || doc === null ? '' : doc.toString(), docBody:typeof docBody === 'undefined' || docBody === null ? '' : docBody.toString(), importantDocs:typeof importantDocs === 'undefined' || importantDocs === null ? '' : importantDocs.toString() }));
    }

    /**
     * 获取符合条件的诚信登记信息列表
     * token:String, objectType:int, integrityType:int, specificType:int, orgName:String, startTime:String, endTime:String, startIndex:int, maxSize:int
     */
    GetIntegrityList(token, objectType, integrityType, specificType, orgName, startTime, endTime, startIndex, maxSize){
        return request.post(this.baseurl + 'GetIntegrityList', Qs.stringify({ token:token, objectType:objectType, integrityType:integrityType, specificType:specificType, orgName:orgName, startTime:startTime, endTime:endTime, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 查询诚信报告详细信息
     * token:String, keyID:String
     */
    GetIntegrityRegisterNoticeDetail(token, keyID){
        return request.post(this.baseurl + 'GetIntegrityRegisterNoticeDetail', Qs.stringify({ token:token, keyID:keyID }));
    }

    /**
     * 查询诚信报告列表
     * token:String, oper:String, beginTimeS:String, endTimeS:String, beginTimeD:String, endTimeD:String, startIndex:int, maxSize:int
     */
    SearchIntegrityRegisterNotice(token, oper, beginTimeS, endTimeS, beginTimeD, endTimeD, startIndex, maxSize){
        return request.post(this.baseurl + 'SearchIntegrityRegisterNotice', Qs.stringify({ token:token, oper:oper, beginTimeS:beginTimeS, endTimeS:endTimeS, beginTimeD:beginTimeD, endTimeD:endTimeD, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 提交诚信登记业务单
     * token:String, doc:BusinessDoc, taskName:String, workFlowTemplateName:String, docBody:IntegrityRegisterDoc, importantDocs:ImportantDocList
     */
    submiteIntegrityDoc(token, doc, taskName, workFlowTemplateName, docBody, importantDocs){
        return request.post(this.baseurl + 'submiteIntegrityDoc', Qs.stringify({ token:token, doc:typeof doc === 'undefined' || doc === null ? '' : doc.toString(), taskName:taskName, workFlowTemplateName:workFlowTemplateName, docBody:typeof docBody === 'undefined' || docBody === null ? '' : docBody.toString(), importantDocs:typeof importantDocs === 'undefined' || importantDocs === null ? '' : importantDocs.toString() }));
    }
    /**
     * 诚信登记查询
     * openId：string,eaAreaCode:string,option:string
     */
    QueryIntegrityRegisterByEaAreaCode(openId, eaAreaCode, option) {
        return request.post(this.baseurl + 'QueryIntegrityRegisterByEaAreaCode', Qs.stringify({
            openId: openId,
            eaAreaCode: eaAreaCode,
            option: option
        }));
    }
}

export class IntegrityController {
}
